// extracted by mini-css-extract-plugin
export default {"nav-link":"navbar_nav-link__zL6qZ","nav-link--disabled":"navbar_nav-link--disabled__vhHRc"};